// Small "open this page in its own window" button (Surface C of the
// pop-out windows feature).  Drop it next to a page header / title and
// it'll spawn a BrowserWindow loading /popup/page<currentRoute>.
//
// Browser users (no electronAPI) see nothing — the button gracefully
// hides instead of cluttering the UI with a non-functional control.
//
// Usage:
//   <PopOutPageButton title="Matters" />              — current pathname
//   <PopOutPageButton route="/matters/123" />         — explicit route
//   <PopOutPageButton route="/calendar" width={1400} height={900} />

import { useLocation } from 'react-router-dom'
import { safeOpenPopupWindow } from '../services/token'

export default function PopOutPageButton({ route, title, width = 1200, height = 800 }) {
  const location = useLocation()
  const canPopOut = !!window.electronAPI?.openPopupWindow
  if (!canPopOut) return null

  const path = route || location.pathname
  // Don't show on pages that ARE already popped out — would just
  // spawn more copies of the same window.
  if (path.startsWith('/popup')) return null

  const handlePopOut = () => {
    const popupRoute = `/popup/page${path}${location.search || ''}`
    const popupKey = `page-${path}${location.search || ''}`
    // safeOpenPopupWindow handles the sessionStorage → localStorage migration
    // so pre-multi-window-deploy users don't get bounced to /login (feedback #73).
    safeOpenPopupWindow(popupKey, popupRoute, { width, height })
  }

  return (
    <button
      onClick={handlePopOut}
      title={`Open ${title || 'this page'} in its own window`}
      className="text-gray-400 hover:text-gray-700 text-lg leading-none w-7 h-7 flex items-center justify-center rounded hover:bg-gray-100 transition-colors"
    >
      ⤴
    </button>
  )
}
